import logo from '../../assets/imgs/logo.svg';
import './Header.css';

const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="topbar"></div>
        <div className="mainbar">
          <a href="https://www.onb.ac.at/" className="logo-link">
            <img 
              src={logo} 
              className="logo" 
              alt="Österreichische Nationalbibliothek Logo" 
              width={200} 
              height={41} 
            />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;